import { BetSlipEventObj, TGetFreeBetAmountEvent } from 'interfaces/bet-data';

type TBuildFreeBetArgsFromBets = (
  allBets: BetSlipEventObj[]
) => [events: TGetFreeBetAmountEvent[], isLive: boolean];

export const buildFreeBetArgsFromBets: TBuildFreeBetArgsFromBets = allBets => {
  let isLive = false;
  const events: TGetFreeBetAmountEvent[] = allBets.map(bet => {
    if (!isLive && bet.isLive) {
      isLive = bet.isLive;
    }

    return {
      Coeficient: Number(bet.coeficient),
      SelectionId: bet.eventId
    };
  });

  return [events, isLive];
};
